"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingFormulaId = exports.pricingFormulaForTrip = exports.pricingFormulaRead = void 0;
const first_1 = __importDefault(require("lodash/first"));
const PricingFormula_1 = require("../models/PricingFormula");
const PricingFormulaType_1 = require("../models/PricingFormulaType");
const Trip_1 = require("../models/Trip");
const expect_1 = __importDefault(require("../util/expect"));
const tryOrUndefined_1 = __importDefault(require("../util/tryOrUndefined"));
const Place_1 = require("./Place");
const TripSourceDetail_1 = require("./TripSourceDetail");
const TripTypeDetail_1 = require("./TripTypeDetail");
const User_1 = require("./User");
const Vendor_1 = require("./Vendor");
async function pricingFormulaRead(type, id, firestore) {
    const collection = (0, PricingFormulaType_1.pricingFormulaTypeCollection)(type);
    const result = await firestore.read(collection, id);
    return (0, PricingFormula_1.pricingFormulaDeserialize)(result.value, result.id);
}
exports.pricingFormulaRead = pricingFormulaRead;
async function pricingFormulaForTrip(type, trip, database, firestore) {
    const locations = (0, Trip_1.tripLocationsWithDefault)(trip);
    const pickup = (0, expect_1.default)((0, first_1.default)(locations));
    const id = await pricingFormulaId({
        type,
        uid: type == 'payout' ? trip.driverId : trip.customerId,
        pickupCoordinatesArray: pickup.coordinates,
        pickupName: pickup.name,
        tripSource: trip.source,
        tripType: trip.type,
        vendorId: trip.vendorId,
        database,
        firestore,
    });
    return pricingFormulaRead(type, id, firestore);
}
exports.pricingFormulaForTrip = pricingFormulaForTrip;
/**
 * Finds the pricing formula (e.g. invoice or payout formula) in a cascading pattern
 */
async function pricingFormulaId({ type, uid, pickupCoordinatesArray, pickupName, tripSource, tripType, vendorId, database, firestore, }) {
    // cascading search
    const propertyName = (0, PricingFormulaType_1.pricingFormulaTypePropertyName)(type);
    // try by user ID
    if (uid) {
        const id = await (0, tryOrUndefined_1.default)((0, User_1.userReadPricingFormulaId)(uid, type, database));
        if (id) {
            return id;
        }
    }
    // try by pickup place
    if (pickupCoordinatesArray) {
        const places = await (0, tryOrUndefined_1.default)((0, Place_1.placeListNearCoordinates)(pickupCoordinatesArray, 100, firestore));
        if (places === null || places === void 0 ? void 0 : places.length) {
            const id = places[0][propertyName];
            if (id) {
                return id;
            }
        }
    }
    // try by vendor
    const isWillysEzCaterOrder = vendorId === 'hguYLHlHc9AgLf5aBKXO' && tripSource === 'EZ_CATER';
    if (vendorId && !isWillysEzCaterOrder) {
        const vendor = await (0, Vendor_1.vendorRead)(vendorId, firestore);
        const id = vendor[propertyName];
        if (id) {
            return id;
        }
    }
    // try by vendor -- using pickup name
    if (pickupName && !isWillysEzCaterOrder) {
        const vendor = await (0, tryOrUndefined_1.default)((0, Vendor_1.vendorWithName)(pickupName, firestore));
        if (vendor) {
            const id = vendor[propertyName];
            if (id) {
                return id;
            }
        }
    }
    // try by trip source
    if (tripSource) {
        const detail = await (0, tryOrUndefined_1.default)((0, TripSourceDetail_1.tripSourceDetailWithSource)(tripSource, firestore));
        if (detail) {
            const id = detail[propertyName];
            if (id) {
                return id;
            }
        }
    }
    // try by trip type
    if (tripType) {
        const detail = await (0, tryOrUndefined_1.default)((0, TripTypeDetail_1.tripTypeDetailRead)(tripType, database));
        if (detail) {
            const id = detail[propertyName];
            if (id) {
                return id;
            }
        }
    }
    // fall back to rideshare (only if system hasn't been set up properly)
    const detail = await (0, TripTypeDetail_1.tripTypeDetailRead)('scoopM', database);
    return (0, expect_1.default)(detail[propertyName], `default (rideshare) formula "${propertyName}" property`);
}
exports.pricingFormulaId = pricingFormulaId;
